// Color theme configuration for Xiquet
// Based on casteller colors: white shirt, black sash, red handkerchief, white pants

export const COLOR_THEMES = {
  white: {
    name: 'Blanc',
    color: '#ffffff',
    image: '/xiquet_images/colors/basic_white.png',
    primary: '#000000', // Black sash
    secondary: '#ffffff', // White shirt
    accent: '#d0282c', // Red handkerchief
    background: '#ffffff',
    text: '#000000',
    textSecondary: '#666666',
    border: '#e0e0e0',
    highlight: '#d0282c'
  },
  green: {
    name: 'Verd',
    color: '#3a9636',
    image: '/xiquet_images/colors/basic_green.png',
    primary: '#000000', // Black sash
    secondary: '#3a9636', // Green shirt
    accent: '#d0282c', // Red handkerchief
    background: '#ffffff',
    text: '#000000',
    textSecondary: '#666666',
    border: '#e0e0e0',
    highlight: '#3a9636'
  },
  yellow: {
    name: 'Groc',
    color: '#e8c62b',
    image: '/xiquet_images/colors/basic_yellow.png',
    primary: '#000000', // Black sash
    secondary: '#e8c62b', // Yellow shirt
    accent: '#d0282c', // Red handkerchief
    background: '#ffffff',
    text: '#000000',
    textSecondary: '#666666',
    border: '#e0e0e0',
    highlight: '#e8c62b'
  },
  red: {
    name: 'Vermell',
    color: '#d0282c',
    image: '/xiquet_images/colors/basic_red.png',
    primary: '#000000', // Black sash
    secondary: '#d0282c', // Red shirt
    accent: '#d0282c', // Red handkerchief (keep red)
    background: '#ffffff',
    text: '#000000',
    textSecondary: '#666666',
    border: '#e0e0e0',
    highlight: '#d0282c'
  },
  blue: {
    name: 'Blau',
    color: '#236ca8',
    image: '/xiquet_images/colors/basic_lightblue.png',
    primary: '#000000', // Black sash
    secondary: '#236ca8', // Blue shirt
    accent: '#d0282c', // Red handkerchief
    background: '#ffffff',
    text: '#000000',
    textSecondary: '#666666',
    border: '#e0e0e0',
    highlight: '#236ca8'
  },
  brown: {
    name: 'Marró',
    color: '#6F5930',
    image: '/xiquet_images/colors/basic_brown.png',
    primary: '#000000',
    secondary: '#6F5930',
    accent: '#d0282c',
    background: '#ffffff',
    text: '#000000',
    textSecondary: '#666666',
    border: '#e0e0e0',
    highlight: '#6F5930'
  },
  darkblue: {
    name: 'Blau fosc',
    color: '#2f4f80',
    image: '/xiquet_images/colors/basic_darkblue.png',
    primary: '#000000',
    secondary: '#2f4f80',
    accent: '#d0282c',
    background: '#ffffff',
    text: '#000000',
    textSecondary: '#666666',
    border: '#e0e0e0',
    highlight: '#2f4f80'
  },
  darkturquesa: {
    name: 'Turquesa fosc',
    color: '#3F8087',
    image: '/xiquet_images/colors/basic_darkturquesa.png',
    primary: '#000000',
    secondary: '#3F8087',
    accent: '#d0282c',
    background: '#ffffff',
    text: '#000000',
    textSecondary: '#666666',
    border: '#e0e0e0',
    highlight: '#3F8087'
  },
  granate: {
    name: 'Granat',
    color: '#550E14',
    image: '/xiquet_images/colors/basic_granate.png',
    primary: '#000000',
    secondary: '#550E14',
    accent: '#d0282c',
    background: '#ffffff',
    text: '#000000',
    textSecondary: '#666666',
    border: '#e0e0e0',
    highlight: '#550E14'
  },
  gray: {
    name: 'Gris',
    color: '#747373',
    image: '/xiquet_images/colors/basic_gray.png',
    primary: '#000000',
    secondary: '#747373',
    accent: '#d0282c',
    background: '#ffffff',
    text: '#000000',
    textSecondary: '#666666',
    border: '#e0e0e0',
    highlight: '#747373'
  },
  malva: {
    name: 'Malva',
    color: '#C1B6D7',
    image: '/xiquet_images/colors/basic_malva.png',
    primary: '#000000',
    secondary: '#C1B6D7',
    accent: '#d0282c',
    background: '#ffffff',
    text: '#000000',
    textSecondary: '#666666',
    border: '#e0e0e0',
    highlight: '#C1B6D7'
  },
  orange: {
    name: 'Taronja',
    color: '#E27B27',
    image: '/xiquet_images/colors/basic_orange.png',
    primary: '#000000',
    secondary: '#E27B27',
    accent: '#d0282c',
    background: '#ffffff',
    text: '#000000',
    textSecondary: '#666666',
    border: '#e0e0e0',
    highlight: '#E27B27'
  },
  rosat: {
    name: 'Rosat',
    color: '#E76253',
    image: '/xiquet_images/colors/basic_rosat.png',
    primary: '#000000',
    secondary: '#E76253',
    accent: '#d0282c',
    background: '#ffffff',
    text: '#000000',
    textSecondary: '#666666',
    border: '#e0e0e0',
    highlight: '#E76253'
  },
  turquese: {
    name: 'Turquesa',
    color: '#2BB5A3',
    image: '/xiquet_images/colors/basic_turquese.png',
    primary: '#000000',
    secondary: '#2BB5A3',
    accent: '#d0282c',
    background: '#ffffff',
    text: '#000000',
    textSecondary: '#666666',
    border: '#e0e0e0',
    highlight: '#2BB5A3'
  },
  lila: {
    name: 'Lila',
    color: '#9573A4',
    image: '/xiquet_images/colors/basic_lila.png',
    primary: '#000000',
    secondary: '#9573A4',
    accent: '#d0282c',
    background: '#ffffff',
    text: '#000000',
    textSecondary: '#666666',
    border: '#e0e0e0',
    highlight: '#9573A4'
  },
  bluesky: {
    name: 'Blau cel',
    color: '#59AFD1',
    image: '/xiquet_images/colors/basic_bluesky.png',
    primary: '#000000',
    secondary: '#59AFD1',
    accent: '#d0282c',
    background: '#ffffff',
    text: '#000000',
    textSecondary: '#666666',
    border: '#e0e0e0',
    highlight: '#59AFD1'
  },
  darkgreen: {
    name: 'Verd fosc',
    color: '#366549',
    image: '/xiquet_images/colors/basic_darkgreen.png',
    primary: '#000000',
    secondary: '#366549',
    accent: '#d0282c',
    background: '#ffffff',
    text: '#000000',
    textSecondary: '#666666',
    border: '#e0e0e0',
    highlight: '#366549'
  },
  ralles: {
    name: 'Ralles',
    color: '#DB9FB6',
    image: '/xiquet_images/colors/basic_ralles.png',
    primary: '#000000',
    secondary: '#DB9FB6',
    accent: '#d0282c',
    background: '#ffffff',
    text: '#000000',
    textSecondary: '#666666',
    border: '#e0e0e0',
    highlight: '#DB9FB6'
  },
  lightgreen: {
    name: 'Verd clar',
    color: '#93BB7B',
    image: '/xiquet_images/colors/basic_lightgreen.png',
    primary: '#000000',
    secondary: '#93BB7B',
    accent: '#d0282c',
    background: '#ffffff',
    text: '#000000',
    textSecondary: '#666666',
    border: '#e0e0e0',
    highlight: '#93BB7B'
  }
};

// Map color_code from colla to theme key
const COLOR_CODE_TO_THEME = {
  'darkgreen': 'darkgreen',
  'skyblue': 'bluesky',
  'turquese': 'turquese',
  'lightgreen': 'lightgreen',
  'yellow': 'yellow',
  'darkblue': 'darkblue',
  'lila': 'lila',
  'granate': 'granate',
  'blue': 'blue',
  'red': 'red',
  'green': 'green',
  'brown': 'brown',
  'gray': 'gray',
  'rosat': 'rosat',
  'malva': 'malva',
  'orange': 'orange',
  'white': 'white',
  'darkturquesa': 'darkturquesa',
  'ralles': 'ralles'
};

// Get color preference from localStorage (general preference, used when no user or no colla)
export const getColorPreference = () => {
  const saved = localStorage.getItem('xiquet_color_preference');
  return saved && COLOR_THEMES[saved] ? saved : 'white';
};

// Save color preference to localStorage
export const saveColorPreference = (color) => {
  localStorage.setItem('xiquet_color_preference', color);
};

// Get user's colla-based color preference (returns the colla color as default for the user)
export const getUserCollaColorPreference = (userId) => {
  if (!userId) return null;
  
  try {
    const savedProfile = localStorage.getItem(`user_profile_${userId}`);
    if (savedProfile) {
      const parsed = JSON.parse(savedProfile);
      if (parsed.collaColorCode) {
        const themeKey = COLOR_CODE_TO_THEME[parsed.collaColorCode];
        if (themeKey && COLOR_THEMES[themeKey]) {
          return themeKey;
        }
      }
    }
  } catch (error) {
    console.error('Error loading user colla color preference:', error);
  }
  
  return null;
};

// Get the user's default color (colla color if they have one, white if not)
// This is different from the temporary session color which can be changed via chat/game/color selector
export const getUserDefaultColor = (userId) => {
  // First check if user has a colla color set
  const collaColor = getUserCollaColorPreference(userId);
  if (collaColor) {
    return collaColor;
  }
  
  // Users without a colla default to white
  return 'white';
};

// Get current theme
export const getCurrentTheme = () => {
  const color = getColorPreference();
  return COLOR_THEMES[color];
};

// Get theme for a specific color key
export const getThemeForColor = (colorKey) => {
  return COLOR_THEMES[colorKey] || COLOR_THEMES['white'];
};

/** Hex #RRGGBB — true if all channels > 240 (white / very light shirt themes). */
export const isLightThemeSecondary = (hex) => {
  if (!hex || typeof hex !== 'string' || hex.length < 7) return false;
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  if (Number.isNaN(r) || Number.isNaN(g) || Number.isNaN(b)) return false;
  return r > 240 && g > 240 && b > 240;
};

/** Accent for buttons/focus rings when theme secondary would vanish on white (e.g. login inputs). */
export const getThemeActionColor = (theme) => {
  if (!theme?.secondary) return '#d0282c';
  return isLightThemeSecondary(theme.secondary) ? '#d0282c' : theme.secondary;
};

